import { Outlet } from "react-router-dom";

export default function Anime() {

    return(
        <Outlet/>
    )

    
}